import { HierarchyContextProps, IHierarchyActionRemoveHierarchyNode } from "../interface";

/**
 * Removes a hierarchy node from the cached hierarchy node list.
 *
 * @param state - The current hierarchy context state.
 * @param action - The remove-hierarchy-node action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_removeHierarchyNode = (
  state: HierarchyContextProps,
  action: IHierarchyActionRemoveHierarchyNode,
): HierarchyContextProps => ({
  ...state,
  hierarchyNodes: state.hierarchyNodes.filter((hn) => hn.id !== action.hierarchyId),
});
